'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeof alert !== 'undefined' ? alert : function () {};


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/dom/showError.js
// module id = 410
// module chunks = 0